import React, { useMemo, memo } from "react";
import PropTypes from "prop-types";
import { Polygon } from "@react-google-maps/api";

const PolygonMap = memo(function PolygonMap({ name, paths, path, fillColor, strokeColor, defaultOptions, ...props }) {
  const polygonPaths = paths || path;
  
  // Memoize options to prevent unnecessary re-renders
  const options = useMemo(() => ({
    ...defaultOptions,
    fillColor,
    strokeColor,
  }), [defaultOptions, fillColor, strokeColor]);

  return <Polygon paths={polygonPaths} options={options} {...props} />;
});

PolygonMap.propTypes = {
  name: PropTypes.string.isRequired,
  paths: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.arrayOf(PropTypes.array)
  ]),
  path: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.arrayOf(PropTypes.array)
  ]),
  fillColor: PropTypes.string,
  strokeColor: PropTypes.string,
  defaultOptions: PropTypes.object
};

export default PolygonMap;
